import BaseApi from "util/api/BaseApi";

class GeneralApi extends BaseApi {
    async contactUsAsync(data: any): Promise<any | undefined> {
        return await this.post<any>("contact-us", data)
    }
}

export default GeneralApi
